var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedPtu0)",
    d: "M13.842 5.571h-3.685a3.343 3.343 0 0 0-3.3 3.386V18H9V8.957c0-.771.398-1.243 1.157-1.243h3.685c.759 0 1.158.467 1.158 1.243V18h2.142V8.957a3.344 3.344 0 0 0-3.3-3.386"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedPtu0",
    x1: 8.121,
    x2: 18.24,
    y1: 10.037,
    y2: 15.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A68F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DFFB9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtu);
export default __webpack_public_path__ + "static/media/ptu.2c368fe126801c09a32a836bd383b954.svg";
export { ForwardRef as ReactComponent };